var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.5853H14V14.9186H2V13.5853ZM8.66667 9.69995L12.714 5.65195L13.6567 6.59462L8 12.252L2.34333 6.59529L3.286 5.65195L7.33333 9.69862V2.25195H8.66667V9.69995Z"
  })));
};
export default SvgDownload;